var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarwash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.313,
    height: 62.039,
    viewBox: "0 0 79.313 62.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 14.475)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.036,158.121a4.832,4.832,0,0,1-4.454-2.714l-.426-.866H9.714l.2-.913a3.666,3.666,0,0,1-2.406-1.1A5.938,5.938,0,0,1,6,149.194L3.775,159.315l.039,9.368a4.957,4.957,0,0,0,1.144,9.78H8.4a11.036,11.036,0,0,1,16.419-9.64V158.069Z",
    transform: "translate(0 -149.194)",
    fill: "currentColor"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.162 0.722)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.232,62.6a4.29,4.29,0,0,0-3.739-2.192H136.613a7.259,7.259,0,0,1,.408,4.775h6.106a7.263,7.263,0,0,1,11.35,0h3.729l7.808,13.944a5.274,5.274,0,0,1,.379-2.5,5.4,5.4,0,0,1,2.283-2.523Z",
    transform: "translate(-136.613 -60.411)",
    fill: "currentColor"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.938 29.572)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M283.328,248.744a13.9,13.9,0,0,1-1.258-2.091l-6.269,2.119a4.868,4.868,0,0,1-5.073-1.25c0,10.529.008,4.058.008,13.3h8.657a11.051,11.051,0,0,1,5.969-9.8A12.845,12.845,0,0,1,283.328,248.744Z",
    transform: "translate(-270.727 -246.653)",
    fill: "currentColor"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.319 19.792)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.445,197.841V195.5H417.85a3.208,3.208,0,0,1,0-6.415h3.1a8.408,8.408,0,0,0-7.91-5.561h-3.2c.524,1.823.828,4.182-.2,6.082-.862,1.6-.689,4.875-.689,5.709a3.945,3.945,0,0,1-.2,1.245,11.06,11.06,0,0,1,9.369,10.916h1.668a4.957,4.957,0,0,0,1.652-9.631Z",
    transform: "translate(-408.756 -183.521)",
    fill: "currentColor"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.886 36.182)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.29,289.327A7.561,7.561,0,1,0,89.6,302.27V291.506A7.535,7.535,0,0,0,84.29,289.327Zm0,10.624a3.063,3.063,0,1,1,3.063-3.063A3.062,3.062,0,0,1,84.29,299.951Z",
    transform: "translate(-76.729 -289.327)",
    fill: "currentColor"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.084 36.182)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M356.7,289.328a7.561,7.561,0,1,0,7.561,7.561A7.561,7.561,0,0,0,356.7,289.328Zm0,10.624a3.063,3.063,0,1,1,3.063-3.063A3.062,3.062,0,0,1,356.7,299.952Z",
    transform: "translate(-349.139 -289.328)",
    fill: "currentColor"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.152 15.61)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.54,157.024a2.3,2.3,0,0,0-1.584-.5c-1.8,0-4.182,1.17-4.612,2.279a2.334,2.334,0,0,0-.1,1.737,4.859,4.859,0,0,1,2.445,8.985,11.525,11.525,0,0,0,.938,1.525c1.393,1.932,2.5,2.586,3.231,2.586a1.038,1.038,0,0,0,1.022-1.139c0-1.05-.223-4.676,1-6.948S350.987,158.359,349.54,157.024Z",
    transform: "translate(-343.119 -156.526)",
    fill: "currentColor"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.446 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.169,58.27c-.378-1.933-4.692-3.093-6.051-2.225-2.164,1.382-.533,2.922-1.45,4.551s-3.109,2.736-3.143,7.266c-.024,3.149.864,4.2,1.662,4.2a1.164,1.164,0,0,0,.913-.517,26.244,26.244,0,0,1,2.562-3.226l-.178-.361a4.862,4.862,0,0,1,5.54-6.863A8.168,8.168,0,0,0,65.169,58.27Z",
    transform: "translate(-54.525 -55.753)",
    fill: "currentColor"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.517 7.807)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M139.935,122.1v0a2.254,2.254,0,0,0-2.852-1.41l-6,2.027-3.2-5.216a6.263,6.263,0,0,0-5.307-2.972c-12.9,0-9.328-.024-14.6.073l-3.544-7.2a2.25,2.25,0,0,0-4.038,1.987l4.175,8.485a2.255,2.255,0,0,0,2.061,1.256c5.772-.107,5.309-.1,5.45-.1,0,.04-.067,13.119-.067,38.648a2.7,2.7,0,0,0,5.4,0V138.189h1.166v19.492a2.7,2.7,0,0,0,5.4,0c0-8.5-.008-27.9-.008-37.078a.245.245,0,0,1,.454-.129c.478.778,1.505,2.458,3.754,6.129a2.25,2.25,0,0,0,2.64.956l7.7-2.6A2.25,2.25,0,0,0,139.935,122.1Z",
    transform: "translate(-100.169 -106.149)",
    fill: "currentColor"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.594 5.283)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.757,
    cy: 4.757,
    rx: 4.757,
    ry: 4.757,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarwash);
export default __webpack_public_path__ + "static/media/carwash.49b8c4e748b8eca6ac3c3816962dafb3.svg";
export { ForwardRef as ReactComponent };